var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLatvia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4082C24.8366 32.4082 32 25.2448 32 16.4082C32 7.57165 24.8366 0.408203 16 0.408203C7.16344 0.408203 0 7.57165 0 16.4082C0 25.2448 7.16344 32.4082 16 32.4082Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 0.408203C8.60728 0.408203 2.3869 5.42202 0.550903 12.2343H31.4486C29.6125 5.42202 23.3922 0.408203 15.9997 0.408203Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 32.408C23.3922 32.408 29.6125 27.3942 31.4485 20.5819H0.550903C2.3869 27.3941 8.60728 32.408 15.9997 32.408Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.408203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatvia);
export default __webpack_public_path__ + "static/media/latvia.79e71df8.svg";
export { ForwardRef as ReactComponent };